import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

//OBTIENE LOS INGRESOS POR FECHA 
export const ObtenerIngresosEncabezado = async (data) => {
  return await PrivateInterceptor('Suministros/IngresosBodegaEncabezado/IngresosEncabezadoPorFecha', 'POST', data);
}


//OBTIENE EL SIGUIENTE NUMERO DE INGRESO
export const ObtenerSiguienteNoIngreso = (DatosEncabezado) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaEncabezado/ObtenerSiguienteNoIngresoPorTipo", "POST", {DatosEncabezado});
  return respuesta;
};

// OBTIENE LOS ENCABEZADOS DE LOS INGRESOS POR NO.INGRESO
export const ObtenerEncabezadoIngresos = async (NumeroIngreso) => {
  const result = await PrivateInterceptor(`Suministros/IngresosBodegaEncabezado/ObtenerEncabezadoIngresos`, 'POST', {NumeroIngreso} )
  return result;
}

//OBTIENE EL SIGUIENTE NUMERO DE INGRESO
export const getTiposIngreso = () => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaEncabezado/TiposIngreso", "GET");
  return respuesta;
};

// OBTIENE LAS FACTURAS POR PROVEEDOR
export const FacturasProveedor = async (IdVendor) => {
  const result = await PrivateInterceptor(`Suministros/IngresosBodegaEncabezado/FacturasProveedor`, 'POST', {IdVendor} )
  return result;
}

// VERIFICAR FACTURA REPETIDA PARA EL MISMO PROVEEDOR
export const VerificarFacturaProveedor = async (Informacion) => {
  const result = await PrivateInterceptor("Suministros/IngresosBodegaEncabezado/VerificarFacturaProveedor", "POST", Informacion);
  return result;
};

export const FacturaByConceptoRetencion = async (IdVendor, IdConceptoRetencion) => {
  const result = await PrivateInterceptor(`Suministros/IngresosBodegaEncabezado/FacturaByConceptoRetencion`, 'POST', {IdVendor, IdConceptoRetencion} )
  return result;
}